import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { useEffect, useState } from "react";
import { boatsFetch } from "../../../lib/boatsFetch";

type Country = {
  name: string[];
  entityType: "country";
};

export const Country = ({ defaultValue }: { defaultValue?: string }) => {
  const [country, setCountry] = useState<Country | null>(
    defaultValue ? { name: [defaultValue], entityType: "country" } : null,
  );

  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Country</h3>
      <FormField<FiltersFormT, "country">
        name="country"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <Combobox
                  className="flex w-96"
                  loadOptions={(query) => {
                    const data = boatsFetch<{ data: any[]; success: boolean }>(
                      `/search/locations?only=country${query ? `&query=${query}` : ""}`,
                    ).then((r) => r.data);
                    return data;
                  }}
                  placeholder="Search for country..."
                  value={country}
                  onChange={(v) => {
                    if (v && v.name[0] !== country?.name[0]) {
                      setCountry(v);
                      field.onChange(v.name[0]);
                    } else {
                      setCountry(null);
                      field.onChange("");
                    }
                  }}
                  renderOption={(r) => r.name[0]}
                />
              </FormControl>
            </FormItem>
          );
        }}
      />
    </div>
  );
};
